import React from 'react';

const NavCircle = ({ variant }) => {
	const getStyles = () => {
		switch (variant) {
			case 'active':
				return {
					backgroundColor: 'white',
					border: '2px solid #F98A3C',
				};
			case 'completed':
				return {
					backgroundColor: '#0071CE',
					border: '2px solid #0071CE',
				};
			case 'inactive':
			default:
				return { backgroundColor: 'white', border: '2px solid white' };
		}
	};

	return (
		<div
			style={{
				width: '30px',
				minWidth: '30px',
				height: '30px',
				borderRadius: '999px',
				flexShrink: 0,
				zIndex: 2,
				...getStyles(),
			}}
		></div>
	);
};

export default NavCircle;
